import { render, staticRenderFns } from "./ikidsmodalnote.vue?vue&type=template&id=f69042ec&"
import script from "./ikidsmodalnote.vue?vue&type=script&lang=js&"
export * from "./ikidsmodalnote.vue?vue&type=script&lang=js&"
import style0 from "./ikidsmodalnote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports